import { LanguageService } from '../../../services/language/language.service';
var EntertainmentPackUtils = /** @class */ (function () {
    function EntertainmentPackUtils(languageService) {
        this.languageService = languageService;
    }
    EntertainmentPackUtils.prototype.sortDtvCatalogOnWeight = function (packs) {
        if (this.languageService.getCurrentLanguage() === 'fr') {
            packs.sort(function (pack1, pack2) { return pack2.omapiCharacteristics && pack1.omapiCharacteristics ? pack2.omapiCharacteristics.weightfr - pack1.omapiCharacteristics.weightfr : -1; });
        }
        else {
            packs.sort(function (pack1, pack2) { return pack2.omapiCharacteristics && pack1.omapiCharacteristics ? pack2.omapiCharacteristics.weightnl - pack1.omapiCharacteristics.weightnl : -1; });
        }
    };
    return EntertainmentPackUtils;
}());
export { EntertainmentPackUtils };
